import { USERS_LOGIN, USERS_OTP } from "./SsoB3";

export const DeleteReduxDataLogin = () => {
  return (dispatch) => {
    dispatch({
      type: USERS_LOGIN,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
  };
};

export const DeleteReduxDataOtp = () => {
  return (dispatch) => {
    dispatch({
      type: USERS_OTP,
      payload: {
        data: false,
        errorMessage: false,
      },
    });
  };
};
